module.exports = __webpack_public_path__ + "img/caex.4a6df5b0.png";